
export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center text-sm text-gray-600 space-y-2">
          <p>© 2025 MGMT University – Student Payments Support Portal.</p>
          <p>This site was created as part of MGMT2005 Microcomputer Applications for Business – Group Project.</p>
          <p>All payment information shown is for demonstration and academic purposes only.</p>
          <div className="pt-4">
            <a 
              href="https://readdy.ai/?origin=logo" 
              className="text-blue-600 hover:text-blue-800 transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
